'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var rentProductOverviewGridComponent = exports.rentProductOverviewGridComponent = {
    template: require('./rent-product-overview-grid.html'),
    bindings: {
        products: '<',
        mode: '<'
    },
    controllerAs: 'vm'
};


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rent-product-overview-grid.js
// module id = 989
// module chunks = 0